import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { ApplicationType } from "@libs/api/gateways/plt/plt-gateway.dtos";

export const useTenantsSearchArgumentsHook = () => {
  const [searchParams] = useSearchParams();
  return useMemo(() => {
    const name = searchParams.get("name") ?? "";
    const tenantId = searchParams.get("tenantId") ?? "";
    const crmId = searchParams.get("crmId") ?? "";
    const selfAssertedCrmId = searchParams.get("selfAssertedCrmId") ?? "";
    const applications = (searchParams.getAll("applications") ??
      []) as ApplicationType[];

    const isInactive = (searchParams.get("isInactive") ?? false) as boolean;

    return {
      name,
      tenantIds: tenantId ? [tenantId] : [],
      crmId,
      selfAssertedCrmId,
      isInactive,
      applications
    };
  }, [searchParams]);
};
